var render = function render(){var _vm=this,_c=_vm._self._c;return _c('customize-form',{ref:"form",attrs:{"schema":_vm.formModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }